import gql from 'graphql-tag';
import manualMailFragment from '../manualMail';

export default gql`
  fragment manualMailClickProspectActivityFragment on ManualMailClickProspectActivity {
    id
    url
    manualMail {
      ...manualMailFragment
      action {
        step {
          name
        }
      }
    }
  }
  ${manualMailFragment}
`;
